import { RelativeDateOperator } from '@doss/common-all'
import { GridFilterInputValueProps } from '@mui/x-data-grid-premium'
import { DynamicDateRangePicker } from '~/@/components/inputs/date/dynamic-date-range-picker/dynamic-date-range-picker'

type DynamicRangeFilterInputProps = GridFilterInputValueProps & {
  operator: RelativeDateOperator
  disabled: boolean
  isDateTime?: boolean
}

/**
 * Wrapper component for DynamicDateRangePicker to handle MUI Grid props
 */
export function DynamicRangeFilterInput(
  props: DynamicRangeFilterInputProps & { operator: string },
) {
  const { item, applyValue, operator, disabled, isDateTime } = props

  return (
    <DynamicDateRangePicker
      className="h-9"
      disabled={disabled}
      isDateTime={isDateTime}
      onChange={(dynamicValue, dateRange) => {
        applyValue({
          ...item,
          value: {
            dynamicValue,
            range: dateRange,
          },
        })
      }}
      operator={operator}
      value={item.value?.dynamicValue}
    />
  )
}
